import React from 'react';
import logo_new_footer from '../assets/images/saude-movel-brasil.png';
import icon_instagram from '../assets/images/icon-instagram.png';
import icon_linkedin from '../assets/images/icon-linkedin.png';
import icon_youtube from '../assets/images/icon-youtube.png';


const FooterOther = () => {
  return (
    <footer id="footer" className="footer-bottom">
      <div className="container-fluid">
        <div className="row align-items-start">
          <div className="col-12 col-xl-3 col-lg-3 col-md-12 col-sm-12 text-center text-xl-left text-lg-left">
            <img src={logo_new_footer} className="img img-fluid" alt="Saúde Móvel Brasil" />
          </div>
          <div className="col-12 col-xl-9 col-lg-9 col-md-12 col-sm-12">
            <div className="row">
              <div className="col-12 col-xl-4 col-lg-4 col-md-4 col-sm-4 my-3 text-center text-xl-left text-lg-left text-md-left text-sm-left">
                <h5 className="title-section">
                  <span className="title-footer"><span className="title-bold">Serviços</span></span>
                </h5>
                <ul>
                  <li><a href="/detalhe/prevencao-e-saude-do-trabalhador">Prevenção & Saúde do Trabalhador
                  </a></li>
                  <li><a href="/detalhe/saude-e-cuidado-da-mulher">Saúde & Cuidado da Mulher</a></li>
                  <li><a href="/detalhe/tomografia">Tomografia</a></li>
                  <li><a href="/detalhe/unidade-de-prevencao-e-saude-no-trabalho">Serviços Básicos de Saúde</a></li>
                </ul>
              </div>
              <div className="col-12 col-xl-4 col-lg-4 col-md-4 col-sm-4 my-3 text-center text-xl-left text-lg-left text-md-left text-sm-left">
                <h5 className="title-section">
                  <span className="title-footer">Nossas <span className="title-bold">Redes Sociais</span></span>
                </h5>
                <ul className="social-networks">
                  <li><a href="https://www.instagram.com/saudemovelbrasil/" target="_blank"><img src={icon_instagram} alt="Instagram" /></a></li>
                  <li><a href="https://www.linkedin.com/company/sa%C3%BAde-m%C3%B3vel-brasil" target="_blank"><img src={icon_linkedin} alt="Linkedin" /></a></li>
                  <li><a href="https://www.youtube.com/@SaudeM%C3%B3velBrasil25" target="_blank"><img src={icon_youtube} alt="Youtube" /></a></li>
                </ul>
              </div>
              <div className="col-12 col-xl-4 col-lg-4 col-md-4 col-sm-4 my-3 text-center text-xl-left text-lg-left text-md-left text-sm-left">
                <h5 className="title-section">
                  <span className="title-footer">Nossos <span className="title-bold">Contatos</span></span>
                </h5>
                <ul className="social-networks">
                  <li><a href="call:65998106742">(65) 99810-6742</a></li>
                  <li><a href="mailto:contato@saudemovelbrasil.com">contato@saudemovelbrasil.com</a></li>
                </ul>
              </div>
            </div>   </div>
        </div>
      </div>

      <a href="https://wa.me/556598106742" target="_blank" className="whatsapp-button" title="Fale conosco no WhatsApp">
        <i className="fab fa-whatsapp" ></i>
      </a>
    </footer>

  );
};

export default FooterOther;